import GSAP from 'gsap'


export default class BlockObserver {
	constructor(blocks) {

		this.blocks 				= blocks;
		this.blockObserver 			= null
		this.isIntersecting 		= this.isIntersecting.bind(this)
		this.init 					= this.init.bind(this)
		this.unmount 				= this.unmount.bind(this)

		if( window.document.body.classList.contains('nav--light') ){
			this.navStartState = true
		} else {
			this.navStartState = false
		}

		this.init()

	}

	init() {

		this.blockObserver = new IntersectionObserver(this.isIntersecting, {
			root: null, // Use the viewport as the root
			rootMargin: "-200px 0px 0px 0px", // No additional margin
			threshold: 0, // Trigger when 0 of the video is visible
		})

		this.blocks && this.blocks.forEach( (block) => {
			// Start observing the block element
			this.blockObserver.observe(block)
		})


		this.blockObserverAnim = GSAP.timeline()
		
		const sections = GSAP.utils.toArray("[data-navcolor='light']")
		sections.forEach( (section, index)=>{
			this.blockObserverAnim.to(section,{
				scrollTrigger:{
					trigger:section,
					start:"top 5px",
					end:"bottom 72px",
					onLeaveBack: () => {
						if (index === 0) {
							if(this.navStartState){
								window.document.body.classList.add('nav--light');
							}
							return;
						}
					},
					toggleClass:{
						targets: window.document.body,
						className: "nav--light",
					},
					preventOverlaps:true
				}
			})	
		})

	}

	isIntersecting(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				
				entry.target.classList.add("visible");

			}
		})
	}

	unmount(){
		this.blockObserverAnim = null
		this.blocks && this.blocks.forEach( (block) => {
			// Start observing the block element
			this.blockObserver.unobserve(block)
		})
	}

}
